export function fileInfo(id, path, title, tag, priority, file) {
    return {
        id: id,
        path: path,
        title: title,
        tag: tag,
        priority: priority,
        file: file
    }
}

export function cacheImages(imgArray) {
    return Promise.all(
        imgArray.map((src) => {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.src = src;

                img.onload = () => resolve();
                img.onerror = () => reject(new Error(`Failed to load image: ${src}`));
            });
        })
    );
}

export function createExhibitionFilePath(clientCode, productCode, prefix, name, ext) {
    let path = [clientCode, productCode, name].join("/")
    return `${path}.${ext}`
}

export function getFileExtension(file) {
    return file.split('.').pop();
}
